import { isString } from 'lodash';
import { PropertytemEnum } from '../enums/property-item-type.enum';

const NUMERIC_TYPES: string[] = [PropertytemEnum.INT, PropertytemEnum.REAL, PropertytemEnum.FLOAT];

function coerceSpecValue(value: unknown, dataType?: string): unknown {
    if (!dataType || !NUMERIC_TYPES.includes(dataType) || !isString(value) || value.trim() === '') {
        return value;
    }

    const parsedValue = Number(value.trim());

    return Number.isFinite(parsedValue) ? parsedValue : value;
}

export { coerceSpecValue };
